"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Reference {
  static addToReference(key, object) {
    if (!Reference.internalReferences[key]) {
      Reference.internalReferences[key] = [];
    }

    Reference.internalReferences[key].push(object);
  }

  static getReferences(key) {
    return Reference.internalReferences[key] || [];
  }

}

exports.default = Reference;

_defineProperty(Reference, "internalReferences", []);